import { render, staticRenderFns } from "./scheduledUserDetails.vue?vue&type=template&id=51f5ad32&scoped=true&"
import script from "./scheduledUserDetails.vue?vue&type=script&lang=js&"
export * from "./scheduledUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f5ad32",
  null
  
)

component.options.__file = "scheduledUserDetails.vue"
export default component.exports